import styled from "styled-components/macro";
import { Typography } from "@mui/material";

export const AutocompleteListItem = styled.li`
  font-size: 11px;
  font-weight: 500;
`;

export const AutocompletePropertyName = styled(Typography)`
  display: block;
`;

export const AutocompletePropertyAddress = styled(Typography)`
  font-size: 12px;
  color: #b0bec5;
  display: block;
`;
